<template>
  <div ref="content" style="height: 100%">
    <steps :stepData="stepData" :activeStep="activeStep"/>
    <div ref="container" class="container">
      <div class="title">收费通知书基本信息</div>
      <el-table :data="[info]" border>
        <el-table-column align="center" prop="chargeNoticeNo" label="收费通知书编号" width="180"></el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间" width="210"></el-table-column>
        <el-table-column align="center" prop="businessType" label="来源">
          {{getDict('businessTypeList',info.businessType)}}
        </el-table-column>
        <el-table-column align="center" prop="chargeType" label="收费类型">
          {{getDict('chargeTypeList',info.chargeType)}}
        </el-table-column>
        <el-table-column align="center" prop="chargeStatus" label="状态">
          {{getDict('statusList',info.chargeStatus)}}
        </el-table-column>
        <el-table-column align="center" prop="supplierCompanyName" label="支付">
          <template v-if="info.paymentType !== 1">
            <div v-for="item in info.chargeNoticeAttachmentVOList" class="voucher">
              <img class="el-upload-list__item-thumbnail" :src="item.fileUrl" alt="">
              <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="viewFile(item)">
                <i class="el-icon-view"></i>
              </span>
            </span>
            </div>
          </template>
          <el-button v-if="[3].includes(info.chargeStatus) || [0,3].includes(info.paymentStatus)"
                     style="font-size: 12px;"
                     type="text"
                     @click="visible=true">去支付
          </el-button>
          <span v-if="info.paymentType===1&&[1, 2].includes(info.paymentStatus)">{{getDict('statusList',info.chargeStatus)}}</span>
        </el-table-column>
        <el-table-column
                prop="collectivePurchaseType"
                width="120"
                label="是否集采">
          <template slot-scope="scope">
            <div>{{  Number(info.collectivePurchaseType) === 1 ? '集采' : '非集采'}}</div>
          </template>
        </el-table-column>
      </el-table>
      <table class="table" cellpadding="0">
        <tr>
          <td colspan="2">收费信息</td>
        </tr>
        <tr>
          <td>付款单位</td>
          <td>{{info.payerCompanyName}}</td>
        </tr>
        <tr>
          <td>收费依据</td>
          <td class="theme" :style="{cursor: info.businessType===1 ? 'pointer' : 'auto'}" style="cursor: pointer"
              @click="toAgreement">
            {{info.businessType===1 ? '《易派客平台易资源推广服务协议》' : '《易派客平台询比价服务协议》'}}
          </td>
        </tr>
        <tr>
          <td>费用名称</td>
          <td>
            <template v-if="info.chargeType===0">
              <div v-if="info.businessType===1">易资源服务费</div>
              <div v-if="info.businessType===2">询比价服务费</div>
            </template>
            <div v-else>询比价违约金</div>
          </td>
        </tr>
        <tr>
          <td>收费标准</td>
          <td>按照协议费率收取</td>
        </tr>
        <tr>
          <td>订单周期</td>
          <td v-if="info.businessType===1">
            每月3日前，平台统计下单时间截至上月最后一日23时59分59秒前（12个月内）的当前状态为“待发货” “待收货”
            “交易成功”的所有易资源销售订单，以此作为需收费订单范围
          </td>
          <td v-if="info.businessType===2">{{info.createTime && info.createTime.substr(0,10)}}</td>
        </tr>
        <tr>
          <td>收费金额</td>
          <td style="color: #E50113;font-weight: bold">￥{{info.chargeAmount | thousandsSeparator}}</td>
        </tr>
        <tr v-if="info.businessType===1">
          <td>收款账户</td>
          <td>
            <div>
              <div>易派客电子商务有限公司，开户银行：中信银行北京分行营业部，账号：3110710025010000004</div>
              <div style="font-size: 12px;color: #999999">请您将服务费打入此账号内，打款成功后，将支付凭证图片上传</div>
            </div>
          </td>
        </tr>
        <tr>
          <td>关联单据</td>
          <td>
            <div class="association-number">
              <div :style="{width: info.businessType === 1 ? '84px' : '70px'}">
                {{info.businessType === 1 ? '对账单编号' : '询价单号'}}：
              </div>
              <div
                :style="{width: info.businessType === 1 ? 'calc(100% - 84px)' : 'calc(100% - 70px)'}">
                <template v-if="info.businessType === 2">
                    <span v-for="item in info.statementAccountNoList" :key="item.businessNo">
                      {{item.businessNo}}
                    </span>
                </template>
                <template v-else>
                  <el-button v-for="item in info.statementAccountNoList" type="text" :key="item.businessNo"
                             @click="toDetails(item)">
                    {{item.businessNo}}
                  </el-button>
                </template>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td>{{info.remark}}</td>
        </tr>
      </table>
    </div>
    <eui-btn type="secondary" @click="back">返 回</eui-btn>
    <payment-dialog :visible.sync="visible" :info="info" @success="getData"/>
    <viewer-image ref="view" :previewSrcList="previewSrcList" :src="src"/>
  </div>
</template>

<script>
import paymentDialog from './paymentDialog';
import viewerImage from '@/modules/projectA/components/common/viewer-image';
import steps from '@/modules/projectA/pages/reconciliationManage/common/steps';
import api from '../../api/order';
import { businessTypeList, statusList, chargeTypeList } from './commonData';
import bus from '@/components/common/bus';

export default {
  components: { steps, paymentDialog, viewerImage },
  data() {
    return {
      visible: false,
      activeStep: 1,
      info: {
        businessType: null,
        statementAccountNoList: [],
        chargeNoticeAttachmentVOList: []
      },
      src: ''
    };
  },
  computed: {
    previewSrcList() {
      return this.info.chargeNoticeAttachmentVOList?.map(item => item.fileUrl) || [];
    },
    stepData() {
      let title = '';
      let description = ' ';
      switch (this.info.chargeStatus) {
        case 0:
          this.activeStep = 1;
          this.info.platformConfirmByUserName = '';
          this.info.platformConfirmTime = '';
          // 在线支付
          if (this.info.paymentType === 1) {
            // 支付中
            if ([1, 2].includes(this.info.paymentStatus)) {
              this.activeStep = 2;
              title = '待审核';
              description = '财务人员审核';
            } else if (this.info.paymentStatus === 3) {
              this.activeStep = 2;
              title = '支付失败';
              description = `失败原因：${this.info.paymentResult || '请联系贵公司财务确认具体原因'}`;
            } else {
              title = '待确认或待审核';
            }
          } else {
            title = '待确认或待审核';
          }
          break;
        case 1:
          this.activeStep = 2;
          title = '平台确认';
          description = '平台确认支付状态';
          this.info.platformConfirmByUserName = '';
          this.info.platformConfirmTime = '';
          break;
        case 2:
          this.activeStep = 4;
          if (this.info.paymentType === 1) {
            title = '支付完成';
            this.info.platformConfirmByUserName = '';
          } else {
            title = '平台确认';
            description = '平台确认支付状态';
          }
          break;
        case 3:
          this.activeStep = 2;
          title = '平台驳回';
          break;
        default:
          break;
      }
      return [
        {
          title: '创建',
          description: '平台创建收费通知书',
          handlePeo: this.info.createByUserName,
          creatTime: this.info.createTime
        },
        {
          title: '支付服务费',
          description: '供应商支付服务费',
          handlePeo: this.info.payerByUserName,
          creatTime: this.info.payerTime
        },
        {
          title,
          description,
          handlePeo: this.info.platformConfirmByUserName,
          creatTime: this.info.platformConfirmTime
        },
        {
          title: '完成',
          description: '对账完成',
          handlePeo: '',
          creatTime: ''
        }
      ];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    viewFile(file) {
      this.src = file.fileUrl;
      this.$refs.view.show();
    },
    async getData() {
      const res = await api.getChargeNoticeSupplierDetail({ chargeNoticeId: this.$route.query.chargeNoticeId });
      if (res.code === '200') {
        this.info = res.data;
      }
    },
    /**
     * 详情
     * @param data
     */
    toDetails(data) {
      if (this.info.businessType === 1) {
        this.$router.push({
          path: '/statementDetails',
          query: {
            statementAccountId: data.businessId,
            supplierCompanyId: this.info.payerCompanyId,
            isCancelOrNot: 0
          }
        });
      }
    },
    /**
     * 详情
     * @param data
     */
    toAgreement(data) {
      if (this.info.businessType === 1) {
        this.$router.push({
          path: '/sharedResourceAgreementDetail',
          query: {
            agreementId: this.info.shareAgreementVO?.agreementId
          }
        });
      }
    },
    /**
     *
     * @param type
     * @param value
     * @returns {*}
     */
    getDict(type, value) {
      let list = [];
      switch (type) {
        case 'businessTypeList':
          list = businessTypeList;
          break;
        case 'chargeTypeList':
          list = chargeTypeList;
          break;
        case 'statusList':
          if (this.info.paymentType === 1) {
            if (this.info.paymentStatus === 1 || (this.info.paymentStatus === 2 && value !== 2)) {
              return '支付中';
            } else if (this.info.paymentStatus === 3) {
              return '支付失败';
            }
          }
          list = statusList;
          break;
        default:
          break;
      }
      return list.find(item => item.id === value)?.name;
    },
    /**
     * 返回
     */
    back() {
      bus.$emit('close_current_tags');
      this.$router.push({
        path: '/noticeOfCharge'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "@/assets/css/theme.scss";

  ::v-deep {
    .container {
      padding: 20px !important;
    }

    .el-step__description {
      padding: 0 !important;

      > div {
        width: 100% !important;
      }
    }
  }

  .title {
    font-family: Source Han Sans CN;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 100% */
    margin-bottom: 20px;
  }

  .table {
    margin-top: 20px;
    border-left: 1px solid #DCDCDC;
    border-top: 1px solid #DCDCDC;
    text-align: left;

    > tr:nth-child(1) > td {
      background: #F5F5F5;
      color: #333;
      font-family: Source Han Sans CN;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      height: 40px;
      line-height: 40px; /* 133.333% */
      padding-left: 9px;
      border-right: 1px solid #DCDCDC;
      border-bottom: 1px solid #DCDCDC;
    }

    > tr:nth-child(n+2) {
      display: flex;
      min-height: 50px;
      height: 100%;

      > td {
        display: flex;
        align-items: center;
        border-right: 1px solid #DCDCDC;
        border-bottom: 1px solid #DCDCDC;
        padding: 8px 14px;
        font-family: Source Han Sans CN;
        font-size: 14px;
        font-style: normal;
        font-weight: 350;
        line-height: 18px; /* 100% */
        color: #333333;
      }

      > td:nth-child(1) {
        width: 160px;
      }

      > td:nth-child(2) {
        width: calc(100% - 160px);
      }
    }
  }

  .association-number {
    display: flex;

    ::v-deep {
      .el-button--text {
        padding: 0;
        margin-left: 0;
        margin-right: 10px;
      }
    }
  }

  .theme {
    color: $main-col !important;
  }

  .voucher {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
    line-height: 38px;
    vertical-align: middle;

    &:hover > span {
      display: block;
    }

    > img {
      display: block;
      width: 100%;
      height: 100%;
    }

    > span {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
      transition: opacity .3s;
    }

    .el-upload-list__item-preview {
      font-size: 14px;
      margin-left: 0;
      color: #FFFFFF;
    }
  }
</style>